import React from "react"
import { forwardRef } from "@design-system/core"
import { NewBadgeProps } from "./types"
import { BasicBadge } from "./BasicBadge"

export const NewBadge = forwardRef<NewBadgeProps, "div">((props, ref) => {
  return <BasicBadge {...props} variant="solid" type="urgent" />
})
